// 专注模式
<template>
	<div class="concentrateMode">
		<header>
			<div class="function">
				<el-cascader
					:key="cascaderKey"
					ref="cascader1"
					v-model="currentSelect"
					:options="files"
					:show-all-levels="false"
					:props="{
						expandTrigger: 'hover',
						label: 'caseNameNum',
						value: 'caseIndex',
						children: 'items'
					}"
					@change="handleChange"
				/>
				<div class="text" @click="switchItem(0)">上一项</div>
			</div>
			<div class="currentSelect">
				{{
					noPatientReason
						? noPatientReason
						: files[currentSelect[0]].caseName +
						  files[currentSelect[0]].items[currentSelect[1]]
								.caseName
				}}
			</div>
			<div class="function">
				<el-cascader
					:key="cascaderKey"
					ref="cascader2"
					v-model="currentSelect"
					:options="files"
					:show-all-levels="false"
					:props="{
						expandTrigger: 'hover',
						label: 'caseNameNum',
						value: 'caseIndex',
						children: 'items'
					}"
					@change="handleChange"
				/>
				<div class="text" @click="switchItem(1)">下一项</div>
			</div>
		</header>
		<viewer
			ref="viewer"
			class="viewer"
			:images="showFiles"
			:options="options"
			@inited="initViewer"
		>
			<div
				v-if="currentIndex > 0"
				class="function left"
				@click="switchImg(0)"
			>
				<i class="el-icon-arrow-left" />
			</div>
			<img
				v-for="(item, index) in showFiles"
				:key="index"
				:src="item.url"
				class="img"
				style="opacity:0;"
			/>
			<div
				v-if="currentIndex < showFiles.length - 1"
				class="function right viewer-right"
				:style="{ right: sideBarStatus ? '52px' : '16px' }"
				@click="switchImg(1)"
			>
				<i class="el-icon-arrow-right" />
			</div>
		</viewer>
		<div
			class="opBg"
			:style="{
				transform: !operationStatus
					? 'translateX(100%)'
					: 'translateX(0)'
			}"
		>
			<div class="operation">
				<h1
					v-if="noPatientReason"
					style="font-size:20px;margin-bottom: 40px;"
				>
					患者信息
				</h1>
				<el-form
					v-if="!noPatientReason"
					label-width="80px"
					:model="formData"
				>
					<el-form-item label="审核阶段"
						><el-select
							v-model="formData.phase"
							@change="changePhase"
						>
							<el-option
								v-for="index in checkItemList"
								:key="index"
								:label="'第' + index + '阶段'"
								:value="index"
							/> </el-select
					></el-form-item>
					<el-form-item label="审核条目"
						><el-select
							v-model="formData.item"
							:disabled="formData.phase ? false : true"
							:placeholder="
								formData.phase ? '请选择' : '请选择审核阶段'
							"
						>
							<el-option
								v-for="index in showItems"
								:key="index"
								:label="index"
								:value="index"
							/> </el-select
					></el-form-item>
				</el-form>
				<el-form
					v-if="noPatientReason"
					ref="patientInfoForm"
					label-width="80px"
					:model="formData2"
				>
					<el-form-item label="患者姓名" prop="patientName">
						<el-input
							v-model="formData2.patientName"
							style="width:100%;"
						/>
					</el-form-item>
					<el-form-item label="身份证号" prop="idcard">
						<el-input
							v-model="formData2.idcard"
							style="width:100%;"
						/>
					</el-form-item>
				</el-form>
				<el-button @click="operationStatus = false">收起</el-button>
				<el-button v-if="!noPatientReason" type="primary" @click="save"
					>保存</el-button
				>
				<el-button
					v-if="noPatientReason"
					type="primary"
					@click="queryPatient"
					>查询患者</el-button
				>
				<el-button
					v-if="noPatientReason"
					type="primary"
					@click="savePatient"
					>录入患者</el-button
				>
			</div>
		</div>
		<div
			class="openBg"
			:style="{
				transform: operationStatus
					? 'translateX(100%)'
					: 'translateX(0)'
			}"
			@click="operationStatus = true"
		>
			编辑
		</div>
		<!-- 患者查询 -->
		<el-dialog
			title="患者查询"
			:visible.sync="outerVisible"
			class="patient-seach-dialog"
		>
			<el-dialog
				title="患者详情"
				:visible.sync="innerVisible"
				append-to-body
				style="min-width:600px;"
				class="patient-inner-dialog"
			>
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane
						label="系统信息"
						name="first"
						class="tab-patient"
					>
						<el-row>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>录入时间</span>
										<span>{{
											patientAllDetail.created
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>申请时间</span>
										<span>{{
											patientAllDetail.submit_dateline
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>最后更新时间</span>
										<span>{{
											patientAllDetail.updated
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>综合审核时间</span>
										<span>{{
											patientAllDetail.check_dateline
												| convertTime(
													'YYYY-MM-DD HH:mm:ss'
												)
										}}</span>
									</p>
									<p>
										<span>出组人</span>
										<span>{{
											patientAllDetail.out_username
										}}</span>
									</p>
									<p>
										<span>归档人</span>
										<span>{{
											patientAllDetail.archive_username
										}}</span>
									</p>
									<p>
										<span>是否临时冻结</span>
										<span>{{
											patientAllDetail.tmp_freezed
												? '是'
												: '否'
										}}</span>
									</p>
									<p>
										<span>流程状态</span>
										<span>{{
											patientAllDetail.status
										}}</span>
									</p>
									<p>
										<span>总领药次数</span>
										<span>{{
											patientAllDetail.total_received_times
										}}</span>
									</p>
									<p>
										<span>领药阶段</span>
										<span>{{
											patientAllDetail.receive_phase
										}}</span>
									</p>
									<p>
										<span>暂停原因</span>
										<span>{{
											patientAllDetail.pause_reason
										}}</span>
									</p>
									<p>
										<span>辅助管理员姓名</span>
										<span>{{
											patientAllDetail.em_name
										}}</span>
									</p>
									<p>
										<span>辅助管理员手机号</span>
										<span>{{
											patientAllDetail.em_mobile
										}}</span>
									</p>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>申请来源</span>
										<span>{{
											patientAllDetail.source
										}}</span>
									</p>
									<p>
										<span>录入人</span>
										<span>{{
											patientAllDetail.submit_username
										}}</span>
									</p>
									<p>
										<span>综合审核人</span>
										<span>{{
											patientAllDetail.check_username
										}}</span>
									</p>
									<p>
										<span>入组日期</span>
										<span>{{
											patientAllDetail.in_date
												| convertTime('YYYY-MM-DD')
										}}</span>
									</p>
									<p>
										<span>出组日期</span>
										<span>{{
											patientAllDetail.out_date
												| convertTime('YYYY-MM-DD')
										}}</span>
									</p>
									<p>
										<span>归档时间</span>
										<span>{{
											patientAllDetail.archive_dateline
												| convertTime('YYYY-MM-DD')
										}}</span>
									</p>
									<p>
										<span>变方式重入组</span>
										<span>{{
											patientAllDetail.is_referral
												? '是'
												: '否'
										}}</span>
									</p>
									<p>
										<span>阶段已领药次数</span>
										<span>{{
											patientAllDetail.received_times
										}}</span>
									</p>
									<p>
										<span>轮次</span>
										<span>{{
											patientAllDetail.rounds
										}}</span>
									</p>
									<p>
										<span>本轮起始时间</span>
										<span>{{
											patientAllDetail.round_start_time
										}}</span>
									</p>
									<p>
										<span>出组原因</span>
										<span>{{
											patientAllDetail.out_reason
										}}</span>
									</p>
									<p>
										<span>辅助申请来源</span>
										<span>{{
											patientAllDetail.apply_type
										}}</span>
									</p>
									<p />
								</div>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane
						label="基本信息"
						name="second"
						class="tab-patient"
					>
						<el-row>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>患者ID</span>
										<span>{{ patientAllDetail.id }}</span>
									</p>
									<p>
										<span>姓名</span>
										<span>{{ patientAllDetail.name }}</span>
									</p>
									<p>
										<span>年龄</span>
										<span>{{
											getAge(patientAllDetail.birthdate)
										}}</span>
									</p>
									<p>
										<span>证件类型</span>
										<span>{{
											patientAllDetail.id_type
										}}</span>
									</p>
									<p>
										<span>手机号</span>
										<span>{{
											patientAllDetail.mobile
										}}</span>
									</p>
									<p>
										<span>项目所在省</span>
										<span>{{
											patientAllDetail.province
										}}</span>
									</p>
									<p>
										<span>医院名称</span>
										<span>{{
											patientAllDetail.hospital_name
										}}</span>
									</p>
									<p>
										<span>援助方式名称</span>
										<span>{{
											patientAllDetail.mode_name
										}}</span>
									</p>
									<p>
										<span>入组备注</span>
										<span>{{
											patientAllDetail.remark
										}}</span>
									</p>
									<p>
										<span>户口性质</span>
										<span>{{
											patientAllDetail.hukou_type
										}}</span>
									</p>
									<p>
										<span>医保性质</span>
										<span>{{
											patientAllDetail.yibao_type
										}}</span>
									</p>
									<p>
										<span>公益专员姓名</span>

										<span>{{
											patientAllDetail.volunteer_name
										}}</span>
									</p>
									<p>
										<span>患者身份</span>
										<span>{{
											patientAllDetail.identity
										}}</span>
									</p>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-patient-list">
									<p>
										<span>患者编号</span>
										<span>{{ patientAllDetail.sn }}</span>
									</p>
									<p>
										<span>出生年月日</span>
										<span>{{
											patientAllDetail.birthdate
												| convertTime('YYYY-MM-DD ')
										}}</span>
									</p>
									<p>
										<span>性别</span>
										<span>{{
											patientAllDetail.gender
										}}</span>
									</p>
									<p>
										<span>证件号码</span>
										<span>{{ patientAllDetail.idsn }}</span>
									</p>
									<p>
										<span>所在大区</span>
										<span>{{ patientAllDetail.area }}</span>
									</p>
									<p>
										<span>项目所在市</span>
										<span>{{ patientAllDetail.city }}</span>
									</p>
									<p>
										<span>项目医生</span>
										<span>{{
											patientAllDetail.doctor_name
										}}</span>
									</p>
									<p>
										<span>药房名称</span>
										<el-tooltip
											class="item"
											effect="dark"
											:content="
												patientAllDetail.drugstore_name
											"
											placement="top-start"
										>
											<span>{{
												patientAllDetail.drugstore_name
											}}</span>
										</el-tooltip>
									</p>
									<p>
										<span>援助子项目名称</span>

										<span>{{
											patientAllDetail.project_name
										}}</span>
									</p>
									<p>
										<span>户口所在地</span>
										<span
											>{{
												patientAllDetail.residence_province
											}}-{{
												patientAllDetail.residence_city
											}}-{{
												patientAllDetail.residence_district
											}}</span
										>
									</p>
									<p>
										<span>医保所在地</span>
										<span
											v-if="
												patientAllDetail.medicare_province &&
													patientAllDetail.medicare_city
											"
											>{{
												patientAllDetail.medicare_province
											}}-{{
												patientAllDetail.medicare_city
											}}-{{
												patientAllDetail.medicare_district
											}}</span
										>
									</p>
									<p>
										<span>是否享受医保</span>
										<span>{{
											patientAllDetail.yibao_joined
												? '是'
												: '否'
										}}</span>
									</p>
									<p />
								</div>
							</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerVisible = false">返回</el-button>
					<el-button type="primary" @click="choseThisPatient"
						>选择本患者</el-button
					>
				</div>
			</el-dialog>
			<el-form :inline="true" class="demo-form-inline" label-width="70px">
				<el-form-item label="患者姓名">
					<el-input v-model="patientItemForm.patientName" />
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="patientItemForm.mobile" />
				</el-form-item>
				<el-form-item label="医院名称">
					<el-input v-model="patientItemForm.hospitalName" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="SearchPatinetconditions"
						>查询</el-button
					>
					<el-button type="primary" @click="reset">重置</el-button>
				</el-form-item>
			</el-form>
			<el-table
				ref="multipleTable"
				:data="patientData"
				highlight-current-row
				style="width: 100%"
				@current-change="handleSelectionChange"
			>
				<el-table-column type="index" width="55" />
				<el-table-column label="ID" prop="id" />
				<el-table-column prop="sn" label="患者编号" width="120" />
				<el-table-column prop="name" label="姓名" width="120" />

				<el-table-column prop="address" label="年龄">
					<template slot-scope="scope">
						<p>{{ getAge(scope.row.birthdate) }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="gender" label="性别" />
				<el-table-column
					prop="city"
					label="城市"
					show-overflow-tooltip
				/>
				<el-table-column
					prop="hospital_name"
					label="医院名称"
					show-overflow-tooltip
				/>

				<el-table-column prop="status" label="流程状态" />

				<el-table-column prop="address" label="总次数/阶段" width="120">
					<template slot-scope="scope">
						<p
							v-if="
								scope.row.total_received_times &&
									scope.row.receive_phase
							"
						>
							{{ scope.row.total_received_times }}/{{
								scope.row.receive_phase
							}}
						</p>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							@click="handlePatientDetail(scope.row)"
							>查看</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:page-size="10"
				layout="prev, pager, next"
				:total="patientTotal"
				:current-page.sync="currentPage1"
				@current-change="handleCurrentChange"
			/>
			<div slot="footer" class="dialog-footer">
				<el-button @click="outerVisible = false">取 消</el-button>
				<el-button type="primary" @click="choseThisPatient"
					>选择本患者</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	groudetail,
	checkItemquery,
	fileupdate,
	updateByPap,
	patientquery,
	queryDetail,
	updateByManual
} from '@/api/manage'
import { mapState } from 'vuex'
export default {
	name: 'ConcentrateMaterial',
	data() {
		return {
			currentPage1: 1,
			patientTotal: 0, // 患者个数
			patientData: [],
			patientItemForm: {
				patientName: null,
				mobile: null,
				hospitalName: null
			},
			patientAllDetail: {}, // 患者基本和系统信息
			activeName: 'first',
			innerVisible: false,
			outerVisible: false, // 查询患者弹框
			operationStatus: true, // 编辑栏开合
			formData: {
				phase: undefined,
				item: undefined
			},
			formData2: {
				idcard: undefined,
				patientName: undefined
			},
			// 解决cascader报错bug
			cascaderKey: 1,
			// 当前viewer展示图片中，选中的图片index
			currentIndex: 0,
			// 当前cascader选中index
			currentSelect: [0, 0],
			// viewer配置
			options: {
				inline: true,
				keyboard: true, // 是否支持键盘
				// viewer之后每次选中图片事件
				view: e => {
					this.currentIndex = e.detail.index
					this.formData = {
						phase: this.showFiles[this.currentIndex].phase
							? this.showFiles[this.currentIndex].phase
							: undefined,
						times: this.showFiles[this.currentIndex].times
							? this.showFiles[this.currentIndex].times
							: undefined,
						item: this.showFiles[this.currentIndex].item
							? this.showFiles[this.currentIndex].item
							: undefined
					}
					setTimeout(() => {
						this.showItems = this.checkItemList2[1]
					}, 0)
					if (this.operationStatus) {
						setTimeout(() => {
							var innerImg = document.querySelector(
								'.viewer-canvas img'
							)
							innerImg.style.left = '-12%'
						}, 50)
					}
				}
			},
			id: null,
			projectId: null,
			fileGroup: undefined,
			// 所有图片展示变量
			files: [
				{
					caseName: '加载中',
					caseIndex: 0,
					items: [
						{
							caseName: '···',
							caseIndex: 0
						}
					]
				}
			],
			// viewer展示变量
			showFiles: [
				{
					caseName: '加载中',
					caseIndex: 0,
					items: [
						{
							caseName: '···',
							caseIndex: 0
						}
					]
				}
			],
			allCheck: [], // 所有条目
			filesImage: [], // 放下面的文件图片用于筛选
			checkItemList: 0, // 审核阶段
			checkItemList2: [], // 所有审核条目
			showItems: [], // 审核条目
			// viewer实例
			$viewer: undefined,
			fullScreenStatus: false,
			// 无患者信息原因
			noPatientReason: ''
		}
	},
	computed: {
		...mapState({
			sideBarStatus: state => state.app.sidebar.opened
		})
	},
	watch: {
		// 开关侧边菜单栏主动制造resize事件viewer自动调整宽度
		sideBarStatus(open) {
			var viewerContainer = document.querySelector('.viewer-container')
			var viewer = document.querySelector('.viewer')
			var right = document.querySelector('.viewer-right')
			if (open) {
				right.style.setProperty('right', '52px', 'important')
			} else {
				right.style.setProperty('right', '16px', 'important')
			}
			setTimeout(() => {
				window.dispatchEvent(new Event('resize'))
				if (!this.operationStatus) {
					viewerContainer.style.setProperty(
						'width',
						'100%',
						'important'
					)
					viewer.style.setProperty('width', '100%', 'important')
				}
			}, 300)
		},
		// 解决cascader报错bug
		files(val) {
			++this.cascaderKey
		},
		// 解决cascader报错bug
		currentSelect() {
			++this.cascaderKey
		},
		// 右侧编辑栏调整viewer宽度
		operationStatus(val) {
			var viewerContainer = document.querySelector('.viewer-container')
			var viewer = document.querySelector('.viewer')
			viewerContainer.style.setProperty(
				'width',
				val ? '80%' : '100%',
				'important'
			)
			viewer.style.setProperty('width', val ? '80%' : '100%', 'important')
			var innerImg = document.querySelector('.viewer-canvas img')
			innerImg.style.left = val ? '-12%' : '0'
		},
		// 默认展示第一个阶段的第一个条目
		files(newval, oldval) {
			// 解决cascader报错bug
			++this.cascaderKey
			if (oldval[0].caseName == '加载中') {
				this.showFiles = this.files[0].items[0].subFiles
			}
		},
		checkItemList(val) {
			setTimeout(() => {
				this.showItems = this.checkItemList2[this.formData.phase]
			}, 50)
		},
		'formData.phase'() {
			++this.cascaderKey
		},
		'formData.item'() {
			++this.cascaderKey
		}
	},
	created() {
		// url参数
		this.id = this.$route.params.id * 1
		this.projectId = this.$route.params.projectId * 1
		this.initData()
	},
	mounted() {
		window.onresize = () => {
			// 监听窗口变化调整viewer宽度
			var viewerContainer = document.querySelector('.viewer-container')
			setTimeout(() => {
				if (!this.operationStatus) {
					viewerContainer.style.setProperty(
						'width',
						'100%',
						'important'
					)
				}
			}, 0)
		}
		var vueThis = this
		document.onkeydown = function(e) {
			// 事件对象兼容
			const e1 =
				e ||
				event ||
				window.event ||
				arguments.callee.caller.arguments[0]
			// 键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
			if (e1 && e1.keyCode == 37) {
				if (vueThis.currentIndex == 0) return
				vueThis.switchImg(0)
			} else if (e1 && e1.keyCode == 39) {
				if (vueThis.currentIndex == vueThis.showFiles.length - 1) return
				vueThis.switchImg(1)
			}
		}
	},
	methods: {
		// 录入患者信息
		savePatient() {
			if (!this.formData2.patientName) {
				this.$message({
					message: '请输入患者姓名',
					type: 'warning'
				})
				return
			}
			if (!this.formData2.idcard) {
				this.$message({
					message: '请输入患者身份证',
					type: 'warning'
				})
				return
			}
			if (this.formData2.idcard.length != '18') {
				this.$message({
					message: '身份证长度不足',
					type: 'warning'
				})
				return
			}
			this.$confirm('是否确认修改患者身份信息？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					updateByManual({
						idcard: this.formData2.idcard,
						patientName: this.formData2.patientName,
						id: this.id
					})
						.then(res => {
							this.initData()
						})
						.catch(err => {
							if(err.message.match('查询无该患者')){
								this.$alert('身份证信息不存在于患者信息库中', '查询无该患者', {
								confirmButtonText: '确定'
								})
								return
							}
							this.$message.error(err.message)
						})
				})
				.catch(() => {})
		},
		// 查看患者具体
		handlePatientDetail(row) {
			const info = {
				projectId: row.project_id,
				id: row.id
			}
			queryDetail(info).then(res => {
				this.patientAllDetail = res.data
				this.innerVisible = true
			})
		},
		handleCurrentChange(val) {
			this.patientSearch.pageIndex = val
			patientquery(this.patientSearch).then(res => {
				this.patientData = res.data.records
				this.patientTotal = res.data.size
			})
		},
		handleSelectionChange(val) {
			this.currentRow = val
		},
		// 年龄
		getAge(data) {
			var info = new Date().getTime() - data
			return parseInt(info / 1000 / 365 / 60 / 60 / 24)
		},
		// 重置
		reset() {
			this.patientItemForm = {
				patientName: null,
				mobile: null,
				hospitalName: null
			}
			this.searchPatinetList()
		},
		// 查询患者
		SearchPatinetconditions() {
			this.patientSearch.patientName = this.patientItemForm.patientName
				? this.patientItemForm.patientName.trim()
				: null
			this.patientSearch.mobile = this.patientItemForm.mobile
				? this.patientItemForm.mobile.trim()
				: null
			this.patientSearch.hospitalName = this.patientItemForm.hospitalName
				? this.patientItemForm.hospitalName.trim()
				: null
			patientquery(this.patientSearch).then(res => {
				this.patientData = res.data.records
				this.patientTotal = res.data.size
				this.currentPage1 = 1
			})
		},
		// 点击pap指定患者
		choseThisPatient() {
			if (!this.currentRow) {
				this.$message.error('请选择患者')
				return false
			}
			const info = {
				patientId: this.currentRow.id,
				id: this.id
			}

			this.$confirm('是否确认修改患者身份信息？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					updateByPap(info)
						.then(res => {
							this.initData()
						})
						.catch(err => {
							this.$message.error(err.message)
						})
				})
				.catch(() => {})
		},
		queryPatient() {
			this.currentPage1 = 1
			this.patientSearch = {
				projectId: this.projectId, // 项目ID
				patientName: null,
				mobile: null,
				hospitalName: null,
				pageIndex: 1,
				pageSize: 10
			}
			patientquery(this.patientSearch).then(res => {
				this.patientData = res.data.records
				this.outerVisible = true
				this.patientTotal = res.data.size
			})
		},
		// 左右切换图片按钮
		switchImg(num) {
			var temp1 = this.$viewer
			if (num && this.currentIndex < this.showFiles.length - 1) {
				this.currentIndex += 1
			} else if (this.currentIndex > 0) {
				this.currentIndex -= 1
			}
			temp1.view(this.currentIndex)
		},
		// 拿到viewer实例
		initViewer(viewer) {
			this.$viewer = viewer
			setTimeout(() => {
				this.fullScreenButton = document.querySelector('.viewer-button')
				var innerImg = document.querySelector('.viewer-canvas img')
				this.fullScreenButton.addEventListener('click', e => {
					var top = this.fullScreenButton.getBoundingClientRect().top
					if (top == 100) {
						this.fullScreenStatus = false
						innerImg.style.left = 'unset'
					}
					if (top == -40) {
						this.operationStatus = true
						this.fullScreenStatus = true
						setTimeout(() => {
							innerImg.style.left = '-12%'
						}, 0)
					}
					this.$forceUpdate()
				})
			}, 1000)
			// viewer实例中的方法无法直接调用，需要用局部变量保存使用
			// 不生效：this.$viewer.view(2)
			// 有效：var temp=this.$viewer; temp.view(2)
		},
		// 编辑修改阶段
		changePhase() {
			this.showItems = this.checkItemList2[this.formData.phase]
		},
		// 上一项下一项
		switchItem(num) {
			var maxPhase = this.files.length // 最大阶段数
			var MaxCategory = this.files[this.currentSelect[0]].items.length // 当前阶段最大条目数
			var currentPhase = this.currentSelect[0] + 1 // 当前阶段index+1
			var currentCategory = this.currentSelect[1] + 1 // 当前条目index+1
			var nextPhase // 下一个阶段index
			var nextCategory // 下一条目Index
			// 下一项
			if (num) {
				if (currentPhase < maxPhase) {
					nextPhase =
						currentCategory < MaxCategory
							? currentPhase - 1
							: currentPhase
					nextCategory =
						currentCategory < MaxCategory ? currentCategory : 0
				} else if (currentPhase == maxPhase) {
					if (currentCategory == MaxCategory) {
						this.$message({
							message: '已经是最后一项',
							type: 'warning'
						})
						return false
					} else {
						nextPhase = currentPhase - 1
						nextCategory = currentCategory
					}
				}
			} else {
				// 上一项
				if (currentPhase > 1) {
					if (currentCategory == 1) {
						nextPhase = currentPhase - 2
						nextCategory =
							this.files[this.currentSelect[0] - 1].items.length -
							1
					} else {
						nextPhase = currentPhase - 1
						nextCategory = currentCategory - 2
					}
				} else if (currentPhase == 1) {
					if (currentCategory == 1) {
						this.$message({
							message: '已经是第一项',
							type: 'warning'
						})
						return false
					} else {
						nextPhase = 0
						nextCategory = currentCategory - 2
					}
				}
			}
			this.currentSelect = [nextPhase, nextCategory]
			this.showFiles = this.files[this.currentSelect[0]].items[
				this.currentSelect[1]
			].subFiles
			this.showItems = this.checkItemList2[this.currentSelect[0] + 1]
		},
		// 选择下拉阶段类目展示图片
		handleChange(e) {
			this.showFiles = this.files[this.currentSelect[0]].items[
				this.currentSelect[1]
			].subFiles
			this.showItems = this.checkItemList2[this.currentSelect[0] + 1]
		},
		initData(isSecondRequest, changedFiles) {
			// 获取当前项目所有阶段和条目
			checkItemquery(this.id).then(res => {
				this.checkItemList = res.data.maxPhase
				this.checkItemList2 = res.data.items
			})
			// 查询当前患者材料
			groudetail(this.id).then(res => {
				this.fileGroup = res.data.fileGroup
				this.formInline = {
					patientName: this.fileGroup.patientName,
					idcard: this.fileGroup.idcard
				}
				if (!res.data.files.length) {
					this.$alert('当前记录无材料', '无数据', {
						confirmButtonText: '退出',
						callback: () => {
							this.$store.dispatch(
								'tagsView/delView',
								this.$route
							)
							this.$router.go(-1)
						}
					})
					return
				} else {
					this.files = this.formatSelect(res.data.files)
				}
				if (!this.fileGroup.patientName) {
					this.noPatientReason = this.fileGroup.reason
				} else {
					this.noPatientReason = ''
					this.outerVisible = false
				}
				// 如果是修改后的update信息
				var nextPhase = 0
				var nextCategory = 0
				var nextImgIndex = 0
				if (isSecondRequest) {
					this.files.forEach((item, index) => {
						// 修改后图片对应阶段的index
						if (item.phase == changedFiles.phase) {
							nextPhase = index
						}
					})
					// 根据修改后的文件阶段类目，定位当前index到对应阶段类目
					this.files[nextPhase].items.filter((item, index) => {
						if (item.item == changedFiles.item) {
							nextCategory = index
							item.subFiles.filter((img, imgIndex) => {
								if (img.fileName == changedFiles.fileName) {
									nextImgIndex = imgIndex
								}
							})
						}
					})
					this.currentSelect = [nextPhase, nextCategory]
					this.showFiles = this.files[this.currentSelect[0]].items[
						this.currentSelect[1]
					].subFiles
					this.showItems = this.checkItemList2[
						this.currentSelect[0] + 1
					]
					if (nextImgIndex != 0) {
						console.log(
							'保存修改后的图片在新的类目下是第',
							nextImgIndex
						)
						setTimeout(() => {
							var temp1 = this.$viewer
							temp1.view(nextImgIndex)
						}, 0)
					}
				}
			})
		},
		// 添加用于级联展示的字段
		formatSelect(files) {
			files.forEach((item, index) => {
				var num = 0
				item.items.forEach((subItem, index) => {
					subItem.caseName = subItem.item
					subItem.caseNameNum =
						subItem.item + `（${subItem.subFiles.length}）`
					subItem.caseIndex = index
					num += subItem.subFiles.length
				})
				item.caseName =
					item.phase == 0 ? `无阶段` : `第${item.phase}阶段`
				item.caseNameNum =
					item.phase == 0
						? `无阶段（${num}）`
						: `第${item.phase}阶段 （${num}）`
				item.caseIndex = index
			})
			return files
		},
		save() {
			if (!this.formData.phase) {
				this.$message({
					message: '请选择审核阶段',
					type: 'warning',
					duration: 1000
				})
				return
			}
			if (!this.formData.item) {
				this.$message({
					message: '请选择审核条目',
					type: 'warning',
					duration: 1000
				})
				return
			}
			var img = this.showFiles[this.currentIndex]
			fileupdate({
				fileIds: img.id,
				projectId: img.projectId,
				item: this.formData.item,
				times: img.times,
				phase: this.formData.phase,
				// 本患者材料11，本患者物流12
				groupType: 11
			})
				.then(res => {
					if (res.success) {
						this.$message({
							message: '保存成功',
							type: 'success',
							duration: 1000
						})
						this.initData(1, res.data[0])
					}
				})
				.catch(err => {
					this.$message({
						message: err.message,
						type: 'warning',
						duration: 1000
					})
				})
		}
	}
}
</script>
<style lang="scss" scoped>
.app-main {
	padding: 0 !important;
}
.concentrateMode {
	font-size: 0;
	white-space: nowrap;
	& >>> .el-dialog {
		min-width: 1000px;
	}
	& >>> .patient-seach-dialog {
		.el-dialog__body {
			height: 500px;
			overflow: auto;
			.el-form {
				white-space: normal;
			}
		}
	}
	header {
		position: relative;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 56px;
		z-index: 1;
		background-color: #333;
		.currentSelect {
			color: #fff;
			font-size: 16px;
		}
		.el-cascader {
			display: inline-block;
			vertical-align: top;
		}
		.text {
			display: inline-block;
			vertical-align: top;
			height: 36px;
			line-height: 36px;
			background-color: #1890ff;
			color: #fff;
			font-size: 14px;
			padding-right: 15px;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
		}
		.function {
			font-size: 0;
			&:hover {
				cursor: pointer;
			}
			& >>> .el-input__inner {
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}
		}

		& >>> .el-input::before {
			content: '';
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			left: 35px;
			width: 1px;
			height: 15px;
			background-color: #fff;
		}
		& >>> .el-input__inner {
			border: none;
			background-color: #1890ff;
			padding-left: 50px;
			padding-right: 0px;
			width: 30px;
			&::placeholder {
				color: #fff;
			}
		}
		& >>> .el-input__suffix {
			width: 25px;
			left: 5px !important;
			i {
				color: #fff;
			}
		}
	}
	.viewer {
		background: rgba(255, 255, 255, 0);
		height: calc(100vh - 140px);
		overflow: hidden;
		display: inline-block;
		vertical-align: top;
		width: 80%;
		position: relative;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.function {
			width: 36px;
			height: 36px;
			border-radius: 50%;
			// line-height: 36px;
			text-align: center;
			color: #fff;
			background: rgba(31, 45, 61, 0.11);
			position: absolute;
			z-index: 5;
			top: calc(50% - 70px);
			transform: translateY(-50%);
			transition: all linear 0.1s;
			i {
				vertical-align: middle;
				font-size: 16px;
				line-height: 36px;
				width: 16px;
				height: 16px;
			}
			&:hover {
				cursor: pointer;
				background: rgba(31, 45, 61, 0.22);
			}
		}
		.left {
			left: 16px;
		}
		.right {
			right: 16px;
		}
	}
	& >>> .viewer-container {
		width: 80% !important;
		margin-top: 56px;
		height: calc(100vh - 140px) !important;
		transition: all linear 0.3s;
		.viewer-list {
			display: inline-block;
			margin: 0 auto;
			transform: unset !important;
		}
	}
	& >>> .viewer-canvas img {
		transform: translateX(0);
		transition: all linear 0.1s;
	}
	& >>> .viewer-fixed {
		width: 100% !important;
		margin-top: 0 !important;
		height: 100vh !important;
	}
	.opBg {
		transition: all linear 0.3s;
		background-color: rgba(0, 0, 0, 0.5);
		height: calc(100vh - 140px);
		width: 19.5%;
		display: inline-block;
		vertical-align: top;
		position: fixed;
		top: 140px;
		right: 0;
		transform: translateX(0);
		.operation {
			height: calc(100vh - 140px);
			background-color: #fff;
			display: inline-block;
			vertical-align: top;
			width: 100%;
			border-radius: 4px;
			padding: 30px;
			.el-form {
				height: 400px;
			}
			& >>> .el-input {
				.el-input__inner {
					width: 100%;
				}
			}
		}
	}
	.openBg {
		position: fixed;
		top: 600px;
		right: 0;
		font-size: 16px;
		transition: all linear 0.3s;
		background-color: #1890ff;
		color: #fff;
		width: 50px;
		padding: 10px;
		word-break: break-all;
		white-space: normal;
		text-align: center;
		line-height: 30px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		&:hover {
			cursor: pointer;
		}
	}
}
</style>
